<!--
 * @Author: YuanYuan
 * @Date: 2024-02-23 10:19:00
 * @LastEditTime: 2024-12-25 11:18:46
 * @description: echarts 组件通用方法: id, 高度, loading状态, resize, 实例销毁等
-->
<script>
import uuid from '@/utils/uuid'

export default {
  props: {
    id: {
      type: [String, Number],
      default: () => uuid()
    },
    height: {
      type: Number,
      default: 500
    },
    loading: {
      type: Boolean,
      default: false
    },
    noDataText: String
  },
  data() {
    return {
      chart: null
    }
  },
  created () {
    this.initComponent()
  },
  beforeDestroy () {
    this.chart && this.chart.clear()
    this.chart && this.chart.dispose()
    this.chart = null
  },
  methods: {
    initComponent() {
      // 具体初始化内容写在各自组件内
    },
    attachEvents() {
      const resizeObserver = new ResizeObserver(() => {
        this.chartResize()
      })
      resizeObserver.observe(document.getElementById(this.id))
      this.$once('hook:beforeDestroy', () => {
        resizeObserver.disconnect()
      })
    },
    /* 容器大小发生变化 */
    chartResize () {
      this.chart && this.chart.resize()
    },
    legendEvents() {
      this.chart && this.chart.on('legendselectchanged', params => {
        this.$emit('legend-click', params)
      })
    }
  }
}
</script>